import { $lang, useApiClient } from '@msdk/common'
import { AttachmentFieldDefinition, AttachmentValue, FormNode } from '@msdk/definitions'
import { downloadAttachment } from '@msdk/forms'
import { ButtonIcon, FileDownloadOutlinedIcon, styled, Typography } from '@msdk/ui'
import React from 'react'
import { useRecoilValue } from 'recoil'

const StyledTypographyFileName = styled(Typography)`
  display: flex;
  align-items: center;
`
const StyledButtonIcon = styled(ButtonIcon)`
  margin-left: auto;
  padding: 0;
  margin-right: 0;
`

interface Props {
  node: FormNode
}

export function AttachmentFieldRenderer({ node }: Props) {
  const fd = node.value.fieldDefinition as AttachmentFieldDefinition
  const lang = useRecoilValue($lang)
  const api = useApiClient()
  const isButtonVisible = (): boolean => {
    return fd?.canDownload
  }

  const isButtonDisable = (): boolean => {
    return !(node.value.data as AttachmentValue)?.url
  }

  return (
    <>
      <StyledTypographyFileName variant="body1">
        {node?.value?.data?.toStringForView(lang) ?? '-'}
        {isButtonVisible() && (
          <StyledButtonIcon
            disabled={isButtonDisable()}
            color={isButtonDisable() ? 'secondary' : 'primary'}
            aria-label="Download"
            onClick={() => {
              downloadAttachment(node.value.data as AttachmentValue, api)
            }}
            edge="end"
          >
            <FileDownloadOutlinedIcon />
          </StyledButtonIcon>
        )}
      </StyledTypographyFileName>
    </>
  )
}
